import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable } from 'rxjs';
import { UtilsService } from './utils.service';

@Injectable({
  providedIn: 'root'
})
export class ProfileService {

  constructor(private http: HttpClient, private utils: UtilsService) { }

  getUsersProfile(): Observable<any> {
    let url = this.utils.apiUrl + 'Account/GetUserProfileResponse';
    return this.http.get(url).pipe(catchError(this.utils.processError.bind(this)));
  }

  updateProfile(body: any): Observable<any> {
    let url = this.utils.apiUrl + 'Account/UpdateUserProfile';
    return this.http.post(url, body).pipe(catchError(this.utils.processError.bind(this)));
  }

  getOrderList(): Observable<any> {
    let url = this.utils.apiUrl + 'CustomerOrders/GetOrderItemsList';
    return this.http.get(url).pipe(catchError(this.utils.processError.bind(this)));
  }

  addEnquiry(body: any): Observable<any> {
    let url = this.utils.apiUrl + 'Enquiry/AddGlobalPresenceEnquiry';
    return this.http.post(url, body).pipe(catchError(this.utils.processError.bind(this)));
  }
  addproductEnquiry(body: any): Observable<any> {
    let url = this.utils.apiUrl + 'CustomerConsultation/ProductHighlightEnquiry_new';
    return this.http.post(url, body).pipe(catchError(this.utils.processError.bind(this)));
  }
  getWishList(): Observable<any> {
    let url = `${this.utils.apiUrl}Product/GetWishListByUser`;
    return this.http.post(url, {}).pipe(catchError(this.utils.processError.bind(this)));
  }

  saveCustomerServiceCare(body: any) {
    let url = `${this.utils.apiUrl}CustomerConsultation/CustomerServieCare`;
    return this.http.post(url, body).pipe(catchError(this.utils.processError.bind(this)));
  }

  saveCustomerComplaint(body: any) {
    let url = `${this.utils.apiUrl}CustomerConsultation/SaveBookComplaints`;
    return this.http.post(url, body).pipe(catchError(this.utils.processError.bind(this)));
  }

}
